import { useTheme } from "@emotion/react";
import React from "react";

import { Flex, Icon, Text } from "~/components/blocks";
import { Size } from "~/components/styles/types";

type Props = {
  error: string;
  color?: "pink" | "white";
  fontSize?: Size;
};

export const FieldError = React.memo((props: Props) => {
  const { error, color = "pink", fontSize = "m" } = props;
  const theme = useTheme();

  return (
    <Flex alignItems="center">
      <Icon icon="alert" color={color} size={fontSize} />
      <Text
        whiteSpace="break-spaces"
        color={color}
        paddingLeft={theme.space.xs}
        size={fontSize}
      >
        {error}
      </Text>
    </Flex>
  );
});

FieldError.displayName = "FieldError";
